import React, { useEffect } from 'react';
import CounsellingLanding from "../components/OnlineCounselling/counsellingLanding";
import { GetStaticProps } from 'next';
import fetchUtil from '../utils/fetchUtil';
import { MetaTagsComp } from '../components/MetaTagsComp';
import { CACHE_REVALIDATE_24H } from '../utils/constants';


const OnlineCounciling: React.FC = (props: any) => {
    const { meta } = props.pageData;
    useEffect(() => {
        const customStyle = document.documentElement.style
        customStyle.setProperty('--navbar-color', '#0046c9');
        customStyle.setProperty('--navbar-menu-color', '#ffff')
      }, [])
    return (
        <>
            {props.pageData && <CounsellingLanding eventData={props.pageData} />}
        </>
    )
}
export const getStaticProps: GetStaticProps = async () => {
    const pageData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/online-couselling-page`, 'GET', {}, '', false)
    return {
        props: {
            pageData
        },
        revalidate: CACHE_REVALIDATE_24H,
    };
}

export default OnlineCounciling;